import * as Yup from 'yup';

import SCOPE_TEXTS from './texts';

export interface ScopeValues {
  is_all_sub_orgs: boolean;
  sub_organization_ids: number[];
  is_all_lobs: boolean;
  lobs: string[];
}

export const scopeFieldsValidation = {
  sub_organization_ids: Yup.array().when('is_all_sub_orgs', {
    is: true,
    then: Yup.array(),
    otherwise: Yup.array().min(1, SCOPE_TEXTS.atLeastOneSubOrg),
  }),
  lobs: Yup.array().when('is_all_lobs', {
    is: true,
    then: Yup.array(),
    otherwise: Yup.array().min(1, SCOPE_TEXTS.atLeastOneLob),
  }),
};
